module.exports = __webpack_public_path__ + "static/media/ic_secure.11c4447e.svg";